import { render } from "./chatAI.vue?vue&type=template&id=199869da&scoped=true"
import script from "./chatAI.vue?vue&type=script&lang=js"
export * from "./chatAI.vue?vue&type=script&lang=js"

import "./chatAI.vue?vue&type=style&index=0&id=199869da&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199869da"]])

export default __exports__